'use server';

import { SessionService } from '@/contexts/authentication';

/**
 * Promote one of a character's per-book generated looks to be its primary
 * portrait. Verifies family ownership before mutating.
 */
export async function setCharacterAppearance(
  characterId: string,
  imageUrl: string
): Promise<{ success: boolean; error?: string }> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return { success: false, error: 'Not authenticated' };

  const { getCharacterRepository } = await import('@/contexts/characters/repositories');
  const repo = getCharacterRepository();

  const character = await repo.getById(characterId);
  if (!character || character.familyId !== familyId) {
    return { success: false, error: 'Character not found' };
  }

  await repo.update(characterId, { primaryPortraitUrl: imageUrl });
  return { success: true };
}
